module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', {
    attrs: {
      "aria-label": "page v",
      "id": "page_v",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("For my sisters, Rosi Reed and Kati Bartkowski, who filled my childhood with endless story inspiration. I don’t know who I would be without both of you in my life.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d3e8ac1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781665903363/xhtml/dedication.vue
// module id = 60
// module chunks = 0